import axios from "axios";
import { toast } from "react-toastify";
import { retrieveToken } from "../utils/cryptoStorage";

const API_URL = import.meta.env.VITE_API_URL_NEWS;

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add Authorization token
axiosInstance.interceptors.request.use(
  async (config) => {
    const token = retrieveToken("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle errors globally
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403 || error.response?.status === 401) {
      localStorage.clear();
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

// Centralized error handling for other status codes
const handleError = (error) => {
  if (error.isAxiosError && error.response) {
    const { statusCode, message } = error.response.data;

    if (message) {
      toast.error(message);
    }

    switch (statusCode) {
      case 500:
        throw new Error(
          "Server Error (500): The server encountered an issue. Please try again later."
        );
      case 422:
        throw new Error(
          "Validation Error (422): Invalid or incomplete data provided."
        );
      case 401:
        localStorage.clear();
        window.location.href = "/login";
        throw new Error(
          "Unauthorized (401): Access is denied. Please check your login status."
        );
      default:
        throw new Error(`API Error: Received unexpected status code ${status}`);
    }
  } else {
    throw new Error(error.message || "An unexpected error occurred.");
  }
};

export const ApprovalNewsListing = async (
  page = 1,
  perPage = 10,
  status,
  userId,
  title,
  publishedDate,
  expiryDate,
  author,
  categoryId,
  scheduleDate
) => {
  try {
    let url = `/news-admin/v1?page=${page}&perPage=${perPage}&status=${status}&isMyNewsArticle=0&createdUserId=${userId}`;

    // Simplified parameter checks using optional chaining
    if (title?.length > 0) url += `&title=${title}`;
    if (author?.length > 0) url += `&authorName=${author}`;
    if (categoryId) url += `&newsCategoryId=${categoryId}`;
    if (publishedDate) url += `&publishedDate=${publishedDate}`;
    if (expiryDate) url += `&expiryDate=${expiryDate}`;
    if (scheduleDate) url += `&publishedDate=${scheduleDate}`;

    const response = await axiosInstance.get(url);
    return response.data.data;
  } catch (error) {
    handleError(error);
  }
};
